import { render, staticRenderFns } from "./fgtpwd_3.vue?vue&type=template&id=706355be&scoped=true&"
import script from "./fgtpwd_3.vue?vue&type=script&lang=js&"
export * from "./fgtpwd_3.vue?vue&type=script&lang=js&"
import style0 from "./fgtpwd_3.vue?vue&type=style&index=0&id=706355be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706355be",
  null
  
)

export default component.exports